// extracted by mini-css-extract-plugin
export default {"user_avatar":"styles_user_avatar__Kyh43","wrapper_link":"styles_wrapper_link__uCKMy","slider":"styles_slider__MZsxQ","slider_attachment_icon":"styles_slider_attachment_icon__etCxg"};